/* @generated from adl module ferovinum.datacontracts.carrier */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface CarrierRawRecord {
  id: common_strings.StringNE;
  name: common_strings.StringNE;
  contactName: common_strings.StringNE;
  contactMobile: common_strings.StringNE;
  contactEmail: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeCarrierRawRecord(
  input: {
    id: common_strings.StringNE,
    name: common_strings.StringNE,
    contactName: common_strings.StringNE,
    contactMobile: common_strings.StringNE,
    contactEmail: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): CarrierRawRecord {
  return {
    id: input.id,
    name: input.name,
    contactName: input.contactName,
    contactMobile: input.contactMobile,
    contactEmail: input.contactEmail,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const CarrierRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.carrier","decl":{"annotations":[{"value":{"datasetName":"raw_carrier"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactMobile","default":{"kind":"nothing"},"name":"contactMobile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"CarrierRawRecord","version":{"kind":"nothing"}}};

export const snCarrierRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.carrier", name:"CarrierRawRecord"};

export function texprCarrierRawRecord(): ADL.ATypeExpr<CarrierRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snCarrierRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.carrier.CarrierRawRecord" : CarrierRawRecord_AST
};
